'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */
var Attention = function (_BcReactComponent) {
  _inherits(Attention, _BcReactComponent);

  function Attention() {
    _classCallCheck(this, Attention);

    return _possibleConstructorReturn(this, (Attention.__proto__ || Object.getPrototypeOf(Attention)).apply(this, arguments));
  }

  _createClass(Attention, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      return _react2.default.createElement(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          focusable: 'false',
          'aria-hidden': true,
          className: 'icon-svg-failure ' + className,
          preserveAspectRatio: 'xMinYMin meet',
          viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M16,8 C16,9.44086038 15.6397848,10.7741935 14.9193548,12 C14.1989249,13.2258065 13.2258065,14.1989249 12,14.9193548 C10.7741935,15.6397848 9.44086038,16 8,16 C6.55913962,16 5.22580645,15.6397848 4,14.9193548 C2.77419355,14.1989249 1.8010751,13.2258065 1.08064516,12 C0.360215218,10.7741935 0,9.44086038 0,8 C0,6.55913962 0.360215218,5.22580645 1.08064516,4 C1.8010751,2.77419355 2.77419355,1.8010751 4,1.08064516 C5.22580645,0.360215218 6.55913962,0 8,0 C9.44086038,0 10.7741935,0.360215218 12,1.08064516 C13.2258065,1.8010751 14.1989249,2.77419355 14.9193548,4 C15.6397848,5.22580645 16,6.55913962 16,8 Z M8,9.61290323 C7.59139769,9.61290323 7.24193548,9.75806452 6.9516129,10.0483871 C6.66129032,10.3387097 6.51612903,10.6881719 6.51612903,11.0967742 C6.51612903,11.5053765 6.66129032,11.8548387 6.9516129,12.1451613 C7.24193548,12.4354839 7.59139769,12.5806452 8,12.5806452 C8.40860231,12.5806452 8.75806452,12.4354839 9.0483871,12.1451613 C9.33870968,11.8548387 9.48387097,11.5053765 9.48387097,11.0967742 C9.48387097,10.6881719 9.33870968,10.3387097 9.0483871,10.0483871 C8.75806452,9.75806452 8.40860231,9.61290323 8,9.61290323 Z M6.58064516,4.29032258 L6.83870968,8.67741935 C6.83870968,8.76344102 6.87634425,8.84408619 6.9516129,8.91935484 C7.02688156,8.99462349 7.11827973,9.03225806 7.22580645,9.03225806 L8.77419355,9.03225806 C8.88172027,9.03225806 8.97311844,8.99462349 9.0483871,8.91935484 C9.12365575,8.84408619 9.16129032,8.76344102 9.16129032,8.67741935 L9.41935484,4.29032258 C9.41935484,4.16129032 9.38172027,4.05913962 9.30645161,3.98387097 C9.23118296,3.90860231 9.13978478,3.87096774 9.03225806,3.87096774 L6.96774194,3.87096774 C6.86021522,3.87096774 6.76881704,3.90860231 6.69354839,3.98387097 C6.61827973,4.05913962 6.58064516,4.16129032 6.58064516,4.29032258 Z' })
      );
    }
  }]);

  return Attention;
}(_baseBcReactComponent2.default);

Attention.propTypes = {
  className: _react.PropTypes.string
};

exports.default = Attention;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Attention/Attention.js
// module id = 153
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16